import { SERVICE } from '@/libs/constant';
import type { ServicePopupData } from '@/ui/component';
import type { SessionData } from 'express-session';
import { rune, type View } from 'rune-ts';

export interface SharedData {
  device: 'pc' | 'mo';
  device_type: 'pc' | 'mo' | 'app' | 'tablet';
  theme: keyof typeof SERVICE;
  lang: 'kr' | 'en' | 'jp';
  client_id: string;
  is_app: boolean;
  user?: SessionData['user'];
  app_info?: Express.Locals['app_info'];
  popup_data?: ServicePopupData[];
  skip_channel_talk?: boolean;
}

export const setSharedData = (data: SharedData): SharedData => {
  return data;
};

export const getSharedData = (view: View): SharedData => {
  const shared_data = rune.getSharedData(view);

  return (shared_data ?? { theme: SERVICE.Marpple, device: 'pc', lang: 'kr' }) as SharedData;
};
